import React from 'react'
import { Box, Typography, Chip } from '@mui/material'

const ReservationDays = ({ camperSessions }) => {
  // Early return if no camperSessions provided
  if (!camperSessions || camperSessions.length === 0) {
    return null
  }

  // Filter sessions that have reservation days
  const sessionsWithReservations = camperSessions.filter(
    cs => cs.reservationDays && cs.reservationDays.length > 0
  )

  if (sessionsWithReservations.length === 0) {
    return null
  }

  const formatDate = dateString => {
    // Parse date as local time to avoid timezone conversion issues
    // dateString format: "2026-07-14"
    const [year, month, day] = dateString.split('-').map(Number)
    const date = new Date(year, month - 1, day) // month is 0-indexed
    return date.toLocaleDateString('en-US', {
      weekday: 'short',
      month: 'short',
      day: 'numeric'
    })
  }

  return (
    <Box mt={2} px={2}>
      {sessionsWithReservations.map(camperSession => {
        const { reservationDays } = camperSession

        // Group reservation days by location
        const locationGroups = reservationDays.reduce((groups, rd) => {
          const locationId = rd.location ? rd.location.id : 'unknown'
          const locationName = rd.location ? rd.location.name : null
          if (!groups[locationId]) {
            groups[locationId] = { locationName, days: [] }
          }
          groups[locationId].days.push(rd)
          return groups
        }, {})

        const locationEntries = Object.entries(locationGroups)

        return locationEntries.map(([locationId, { locationName, days }]) => {
          const heading = locationName
            ? `Reserved Dates at ${locationName}`
            : 'Reserved Dates'

          return (
            <Box key={`${camperSession.id}-${locationId}`} mb={2}>
              <Typography variant='subtitle1' gutterBottom>
                {heading}
              </Typography>
              <Box display='flex' flexWrap='wrap' gap={1}>
                {[...days]
                  .sort((a, b) => {
                    // Parse dates as local time for correct sorting
                    const [yearA, monthA, dayA] = a.date.split('-').map(Number)
                    const [yearB, monthB, dayB] = b.date.split('-').map(Number)
                    const dateA = new Date(yearA, monthA - 1, dayA)
                    const dateB = new Date(yearB, monthB - 1, dayB)
                    return dateA - dateB
                  })
                  .map(rd => {
                    const dateStr = formatDate(rd.date)
                    const label = rd.locationDay
                      ? `${dateStr} - ${rd.locationDay.title}`
                      : dateStr

                    return (
                      <Chip
                        key={rd.id}
                        label={label}
                        size='small'
                        variant='outlined'
                        color='primary'
                      />
                    )
                  })}
              </Box>
            </Box>
          )
        })
      })}
    </Box>
  )
}

export default ReservationDays
